import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCommentDots} from '@fortawesome/free-solid-svg-icons';

interface TechnicalSupportButtonProps {
    phoneNumber: string;
    className?: string;
}

export const TechnicalSupportButton: React.FC<TechnicalSupportButtonProps> = ({
                                                                                  phoneNumber,
                                                                                  className = ''
                                                                              }) => {
    const handleClick = () => {
        // URL để mở Zalo chat
        const zaloUrl = `https://zalo.me/${phoneNumber}`;
        window.open(zaloUrl, '_blank');
    };

    return (
        <button
            onClick={handleClick}
            className={`
                fixed bottom-8 right-4 z-40
                flex items-center gap-2 
                px-4 py-2
                bg-slate-800
                hover:bg-slate-900
                text-white font-medium
                rounded-full
                shadow-lg hover:shadow-xl
                dark:shadow-slate-900
                transform hover:-translate-y-0.5
                transition-all duration-200
                ${className}
            `}
        >
            <FontAwesomeIcon icon={faCommentDots} className="w-5 h-5"/>
            <span>Hỗ trợ kỹ thuật</span>
        </button>
    );
};